function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgFinancial = function SvgFinancial(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    d: "M9.9 15.6c1.05 0 2.1-.6 2.1-1.8 0-2.4-4.2-1.163-4.2-3.6 0-1.219 1.05-1.819 2.1-1.814m0 7.214c-1.05 0-2.1-.6-2.1-1.8m2.1 1.8v1.2m2.1-6.6c0-1.2-1.05-1.81-2.1-1.814m0 0V7.2m0 1.186V8.4m7.5 3.6a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0Zm0 0a7.5 7.5 0 0 0-4.497-6.875M17.4 12a7.5 7.5 0 0 1-4.497 6.875M16.2 5.158a6.901 6.901 0 0 1 0 13.684"
  }));
};
export default SvgFinancial;